export function formatSsn(rawValue: string): string {
  const digits = rawValue.replaceAll(/\D/g, '').slice(0, 9)

  const first = digits.slice(0, 3)
  const second = digits.slice(3, 5)
  const third = digits.slice(5, 9)

  if (digits.length <= 3) {
    return first
  }

  if (digits.length <= 5) {
    return `${first}-${second}`
  }

  return `${first}-${second}-${third}`
}

export function maskSsnForView(rawValue: string): string {
  const formattedValue = formatSsn(rawValue)

  if (!formattedValue) {
    return '•••-••-••••'
  }

  const lastFour = rawValue.replaceAll(/\D/g, '').slice(-4)

  if (lastFour.length < 4) {
    return formattedValue
  }

  return `•••-••-${lastFour}`
}
